// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Header-module--bx--text-truncate--end--_MmpY";
export var bxTextTruncateFront = "Header-module--bx--text-truncate--front--lNZQx";
export var header = "Header-module--header--3F8hM";
export var headerButton = "Header-module--header-button--1HgW3";
export var headerName = "Header-module--headerName--3bWYU";
export var headerNameWithHeaderNav = "Header-module--headerNameWithHeaderNav--1qa5i";
export var headerWithHeaderNav = "Header-module--headerWithHeaderNav--3d1PO";
export var searchIsOpenOnBar = "Header-module--searchIsOpenOnBar--10tId";
export var searchIsOpenOnLink = "Header-module--searchIsOpenOnLink--2EsJX";
export var skipToContent = "Header-module--skip-to-content--2JxOW";
export var switcherButton = "Header-module--switcher-button--2vfiP";
export var switcherButtonOpen = "Header-module--switcher-button--open--N2ANn";